var app = app || {};
app.namespace = function(e) {
    var t, i = e.split("."),
        a = app;
    for ("app" === i[0] && (i = i.slice(1)), t = 0; t < i.length; t += 1) "undefined" == typeof a[i[t]] && (a[i[t]] = {}), a = a[i[t]];
    return a
}